import { Injectable } from "@angular/core";
import { RequestAuth, ResponseAuth } from "../dto/auth.dto";
import { RecruitmentApi } from "../recruitment-api";
import { ResponseData } from "../recruitment-responses";

@Injectable()
export class AuthApi {

    private model: string = 'users';

    constructor(
        private recruitmentApi: RecruitmentApi
    ) { }

    login(data: RequestAuth, key?: string) {
        const method: string = 'POST';
        const func: string = 'login';
        const params: RequestAuth = data;
        const urlParams: any = {
            key: key
        };
        const body: any = {};
        const url = this.recruitmentApi.urlBuilder(method, this.model, func, params, urlParams);
        return this.recruitmentApi.request<ResponseData<ResponseAuth>>(method, url, params, urlParams, body);
    }

    register(email: string, password: string, nik: string, key: string) {
        const method: string = 'POST';
        const func: string = 'register';
        const params: any = {
            email: email,
            password: password,
            nik: nik,
        };
        const urlParams: any = {
            key: key
        };
        const body: any = {};
        const url = this.recruitmentApi.urlBuilder(method, this.model, func, params, urlParams);
        return this.recruitmentApi.request<ResponseData<ResponseAuth>>(method, url, params, urlParams, body);
    }

    logout() {
        const method: string = 'POST';
        const func: string = 'logout';
        const params = null;
        const urlParams: any = {};
        const body: any = {};
        const url = this.recruitmentApi.urlBuilder(method, this.model, func, params, urlParams);
        return this.recruitmentApi.request<ResponseData<ResponseAuth>>(method, url, params, urlParams, body, null, 30000, true);
    }

    profile() {
        const method: string = 'GET';
        const func: string = 'getProfile';
        const params = null;
        const urlParams: any = {};
        const body: any = {};
        const url = this.recruitmentApi.urlBuilder(method, 'employees', func, params, urlParams);
        return this.recruitmentApi.request<ResponseData<ResponseAuth>>(method, url, params, urlParams, body, null, 30000, true);
    }

    forgotPassword(email: string) {
        const method: string = 'POST';
        const func: string = 'sendResetPassword';
        const params: any = {
            email: email
        };
        const urlParams: any = {};
        const body: any = {};
        const url = this.recruitmentApi.urlBuilder(method, this.model, func, params, urlParams);
        return this.recruitmentApi.request<ResponseData<ResponseAuth>>(method, url, params, urlParams, body);
    }

    resetPassword(password: string, passwordRe: string, key: string) {
        const method: string = 'POST';
        const func: string = 'resetPassword';
        const params: any = {
            password: password,
            passwordRe: passwordRe,
            key: key
        };
        const urlParams: any = {};
        const body: any = {};
        const url = this.recruitmentApi.urlBuilder(method, this.model, func, params, urlParams);
        return this.recruitmentApi.request<ResponseData<ResponseAuth>>(method, url, params, urlParams, body);
    }

}


// WEBPACK FOOTER //
// ./src/shared/recruitment/services/auth.api.ts